import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import PurchaseCategoryService from "services/PurchaseCategoryService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getPurchaseCategoryApi = createAsyncThunk(
  "purchaseCategory/getPurchaseCategoryApi",
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseCategoryService.getPurchaseCategories(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addPurchaseCategoryApi = createAsyncThunk(
  "purchaseCategory/addPurchaseCategoryApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response =
        await PurchaseCategoryService.createPurchaseCategory(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updatePurchaseCategoryApi = createAsyncThunk(
  "purchaseCategory/updatePurchaseCategoryApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response =
        await PurchaseCategoryService.updatePurchaseCategory(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delPurchaseCategoryApi = createAsyncThunk(
  "purchaseCategory/delPurchaseCategoryApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await PurchaseCategoryService.deletePurchaseCategory(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,

  purchaseCategoryList: [],

  currentRequestId: undefined,
};

export const purchaseCategorySlice = createSlice({
  name: "purchaseCategory",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseCategoryApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getPurchaseCategoryApi.fulfilled, (state, action) => {
        state.loading = false;
        state.purchaseCategoryList = action.payload || [];
      })
      .addCase(getPurchaseCategoryApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(addPurchaseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPurchaseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addPurchaseCategoryApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updatePurchaseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePurchaseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePurchaseCategoryApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(delPurchaseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delPurchaseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(delPurchaseCategoryApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = purchaseCategorySlice.actions;

export default purchaseCategorySlice.reducer;
